import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import createConfigs from '@/config/index';

import launchGetEventDetail, {
  ResolvedEventDetailData,
} from '@/app/events/launchGetEventDetail';

import Head from 'next/head';
import { useRouter } from 'next/router';
import Layout from '@/interface/ui/_shared/layout/index';
import styles from '@/interface/ui/events/[id].module.scss';
import type Event from '@/domain/events/index';
import CalenderButtonGroup from '@/interface/ui/_shared/items/calenderButtonGroup';
import { RootState } from '@/store';
import { useEventContent } from '@/hooks/useEventContent';
import { NextPage } from 'next';

interface Props {
  mode?: 'default';
}

const Page: NextPage<Props> = ({ mode }): React.ReactNode => {
  const router = useRouter();
  const [event, setEventDetail] = useState<Event | null>(null);

  const itemId = router.query.id as string;
  const contentUri = `${
    createConfigs().apiServer.origin
  }/v1/events/${itemId}/show_html`;

  const { content } = useEventContent(contentUri);

  const eventDetailGet = useCallback(async () => {
    try {
      const data = await launchGetEventDetail({
        eventId: itemId,
      });
      setEventDetail(data);
    } catch (error) {
      console.log('GET EVENTS ERROR', error);
    }
  }, [itemId]);

  useEffect(() => {
    launchGetEventDetail({ eventId: itemId });
    void eventDetailGet();
  }, [eventDetailGet, itemId]);

  function Iframe(props: { iframe: string }) {
    return <div dangerouslySetInnerHTML={{ __html: props.iframe || '' }} />;
  }

  const { userAgent } = useSelector((state: RootState) => state.app);

  const renderEventDetail = (userAgents: string | undefined) => {
    if (event) {
      return (
        <div>
          <img
            loading="lazy"
            src={event.coverImage}
            alt={event.title}
            className={styles.image}
          />
          <div className={styles.body}>
            <p className={styles.title}>{event.title}</p>
            <div className={styles.releaseWrapper}>
              <p>{event.releaseAt}</p>
            </div>
            <Iframe iframe={content} />
            {event.canCalendar && (
              <div className={styles.contents}>
                <CalenderButtonGroup
                  item={event}
                  userAgent={userAgents}
                  calTitle={'カレンダーに登録'}
                  position={'right'}
                />
              </div>
            )}
          </div>
        </div>
      );
    }
  };

  const renderRightBlock = () => {
    return (
      <div className={styles.rightBlock}>
        <p className={styles.rightText}></p>
      </div>
    );
  };

  return (
    <>
      <Head>
        <title>{event?.title || 'イベント'}</title>
        <meta name="description" content="content" />
        <meta property="og:title" content="content" key="title" />
      </Head>
      <Layout mode={mode}>
        <div className={styles.container}>
          {renderEventDetail(userAgent)}
          {renderRightBlock()}
        </div>
      </Layout>
    </>
  );
};

export default Page;
